import { render, staticRenderFns } from "./header-tabs.vue?vue&type=template&id=59ef2b7c&"
import script from "./header-tabs.vue?vue&type=script&lang=js&"
export * from "./header-tabs.vue?vue&type=script&lang=js&"
import style0 from "./header-tabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports